/**
 * Single backend root from REACT_APP_API_URL (e.g. http://localhost:5000).
 * API calls use {origin}/api; media uses {origin}.
 */
export function apiOrigin() {
  const raw = (process.env.REACT_APP_API_URL || 'http://localhost:5000').trim();
  return raw.replace(/\/api\/?$/, '').replace(/\/$/, '') || 'http://localhost:5000';
}

export function apiBaseUrl() {
  return `${apiOrigin()}/api`;
}
